import type { EmployeeAlertLastContractEndDateNotSameAsResignationDate } from '@/common/graphql';

import { DateWithCount } from '../DateWithCount';

export const DetailDescriptionEmployeeAlertLastContractEndDateNotSameAsResignationDate = ({
  reason,
}: {
  reason: Pick<EmployeeAlertLastContractEndDateNotSameAsResignationDate, 'lastEndDate' | 'resignationDate'>;
}) => (
  <>
    <div>
      <DateWithCount prefix="Last contract end date" date={reason.lastEndDate} />
    </div>
    <div>
      <DateWithCount prefix="Employment end date" date={reason.resignationDate} />
    </div>
  </>
);
